<template>
  <section class="album py-5 bg-light custom-middle-section">
    <div class="container-fluid">
      <div class="album py-5">
        <div class="container">
          <div class="row text-center align-items-center">
            <div
                v-for="(item) in priceListForProduct[this.productDetail]"
                :key="item.id"
                class="col-md-6"
            >
              <img
                  :class="['price-img-active']"
                  v-lazy="item.image"
                  alt="price"
              />
            </div>
            <div class="col-md-6">
              <div v-for="item in priceListForProduct[this.productDetail]" :key="item.id">
                <h2 class="row my-4">{{item.title}}</h2>
                <h4 v-for="(price, i) in item.prices" :key="price" class="d-flex flex-row">
                  <div v-if="Math.floor(Date.now() / 1000) < 1764543600">
                    {{item.sizes[i]}} | <span style="opacity: 0.6; text-decoration: line-through">{{price}}</span> <span style="color: #D32F2F">{{item.bfPrices[i]}}</span>
                  </div>
                  <div v-else>
                    {{item.sizes[i]}} | {{price}}
                  </div>
                </h4>
                <div class="price-desc mt-4">
                  <div v-for="point in item.points" :key="point" class="d-flex flex-row">
                    <div class="custom-icon">
                      <font-awesome-icon icon="check-circle" class="mr-2" />
                    </div>
                    <div>{{point}}</div>
                  </div>
                </div>
                <h5 class="row mt-4">
                  {{$t("price.other")}}
                </h5>
                <div class="price-desc mt-4">
                  <div v-for="p in item.products" :key="p.id" class="d-flex flex-row">
                    <b-button v-on:click="productDetail = p.id; updateQuery(p.id)" class="mt-2 btn-light">{{p.title}}</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <poster-button
                :button-text="$t('testimonial.button_text', {kw: $route.query.kw ? $route.query.kw : kw})"
                :product-detail="productDetail"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { BButton } from "bootstrap-vue";
import PosterButton from "./generic/PosterButton";
import i18n from "../i18n";

const pricePoster1 = require('../assets/images/'+ process.env.VUE_APP_BASE_LOCALE +'/price-1.png');

export default {
  name: "PriceDetail",
  components: {
    PosterButton,
    BButton,
  },
  props: {
    productDetail: {
      type: String,
    },
  },
  data() {
    let prc = process.env.VUE_APP_PRE_CURRENCY;
    let poc = process.env.VUE_APP_POST_CURRENCY;

    let priceListForProduct = {};

    priceListForProduct.pdf = [{
      id: 1,
      title: this.$t("price.list.item_one.heading"),
      image: pricePoster1,
      sizes: [
       this.$t("price.no_shipping_fee"),
      ],
      prices: [
        prc+"19"+poc,
      ],
      bfPrices: [
        prc+"5"+poc,
      ],
      points: [
        this.$t("price.list.item_one.sub_list.one"),
        this.$t("price.list.item_one.sub_list.two"),
        this.$t("price.list.item_one.sub_list.three")
      ],
      products: [
        {
          title: this.$t("price.list.item_two.heading"),
          id: "poster",
        },
        {
          title: this.$t("price.list.item_three.heading"),
          id: "metal",
        }
      ],
    }]

    priceListForProduct.poster = [{
      id: 1,
      title: this.$t("price.list.item_two.heading"),
      image: pricePoster1,
      sizes: [
        "40cm x 50cm ",
        "50cm x 70cm ",
        "70cm x 100cm",
      ],
      prices: [
        prc+"44"+poc,
        prc+"49"+poc,
        prc+"69"+poc,
      ],
      bfPrices: [
        prc+"39"+poc,
        prc+"44"+poc,
        prc+"62"+poc,
      ],
      points: [
        this.$t("price.list.item_two.sub_list.one"),
        this.$t("price.list.item_two.sub_list.two"),
        this.$t("price.list.item_two.sub_list.three"),
      ],
      products: [
        {
          title: this.$t("price.list.item_one.heading"),
          id: "pdf",
        },
        {
          title: this.$t("price.list.item_three.heading"),
          id: "metal",
        }
      ],
    }]

    priceListForProduct.metal = [{
      id: 1,
      title: this.$t("price.list.item_three.heading"),
      image: pricePoster1,
      sizes: [
        "40cm x 50cm",
        "50cm x 70cm",
      ],
      prices: [
        prc+"89"+poc,
        prc+"99"+poc,
      ],
      bfPrices: [
        prc+"69"+poc,
        prc+"79"+poc,
      ],
      points: [
        this.$t("price.list.item_three.sub_list.one"),
        this.$t("price.list.item_three.sub_list.two"),
        this.$t("price.list.item_three.sub_list.three"),
      ],
      products: [
        {
          title: this.$t("price.list.item_one.heading"),
          id: "pdf",
        },
        {
          title: this.$t("price.list.item_two.heading"),
          id: "poster",
        }
      ],
    }]

    return {
      locale: i18n.locale,
      kw: process.env.VUE_APP_KW,
      priceListForProduct: priceListForProduct,
    };
  },
  methods: {
    updateQuery: function (id) {
      const query = { ...this.$route.query, productDetail: id};
      this.$router.replace({ query });
    },
  }
};
</script>